import { render } from "./PasswordCredential.vue?vue&type=template&id=d3c5168a&scoped=true"
import script from "./PasswordCredential.vue?vue&type=script&lang=js"
export * from "./PasswordCredential.vue?vue&type=script&lang=js"

import "./PasswordCredential.vue?vue&type=style&index=0&id=d3c5168a&lang=scss&scoped=true"

import exportComponent from "D:\\workpace\\yt-portal-layout\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3c5168a"]])

export default __exports__